import React from "react";

import Moment from "moment";
import "moment/locale/sk";
import "moment/locale/cs";
import "moment/locale/de";
import "moment/locale/en-gb";
import "./function-fixes.js";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Switch, withRouter } from "react-router";
import { userContextActions } from "./store/userContextStore";
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";
import { isRepiWeb } from "./store/storeFunctions.jsx";
import { getLanguage, getMomentLanguage } from "./store/apiWrapper";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import RepiLayout from "./components/template/repiLayout";
import PublicLayout from "./components/template/publicLayout";
import PrivateLayoutNew from "./components/template/privateLayoutNew";

import MonitoringLandingPage from "./components/monitoring/monitoringLandingPage";
import IratingComponent from "./components/irating/iratingComponent";
import CookieInfoComponent from "./components/layoutItems/cookieInfoComponent";
import PrivacyPolicyInfoComponent from "./components/layoutItems/privacyPolicyInfoComponent";
import SkyminderComponent from "./components/skyminder/skyminderComponent";
import SkyminderSsoComponent from "./components/skyminder/skyminderSsoComponent";
import ContactComponent from "./components/contact/contactComponent";
import PersonalDataComponent from "./components/personalData/personalDataComponent";
import AmlInfoCheckComponent from "./components/aml/amlInfoCheckComponent";
import SearchComponent from "./components/search/searchComponent";
import SearchResults from "./components/search/searchResults";
import CeeSearchComponent from "./components/search/ceeSearchComponent";
import LiensSearchComponent from "./components/search/liensSearchComponent";
import BankruptcySearchComponent from "./components/search/bankruptcySearchComponent";
import IndustryAnalysisComponent from "./components/search/industryAnalysis/industryAnalysisComponent";
import PropertyCzSearchComponent from "./components/search/propertyCzSearchComponent";
import PropertySkSearchComponent from "./components/search/propertySkSearchComponent";
import ReportComponent from "./components/report/reportComponent";
import StylingComponent from "./components/styling/stylingComponent";
import NotAuthorizedComponent from "./components/layoutItems/notAuthorizedComponent";
import NotFoundComponent from "./components/layoutItems/notFoundComponent";
import RelationChartComponent from "./components/relationChart/relationChartComponent";
import MarketingListLandingPage from "./components/marketingList/marketingListLandingPage";
import HomeComponent from "./components/home";
import NewsComponent from "./components/news/newsComponent";
import NewsDetailComponent from "./components/news/newsDetailComponent";
import ConflictOfInterestSearchComponent from "./components/search/conflictOfInterestSearchComponent";
import RelationsSearchLandingPage from "./components/search/relations/relationsSearchLandingPage";
import ReportUnlimitedComponent from "./components/report/reportUnlimitedComponent";
import RelationsAddressesData from "./components/reportSections/relations/relationsAddressData";
import WarningsReportComponent from "./components/report/warningsReportComponent";
import MarketingListOverviewWindow from "./components/marketingList/overviewWindow";
import RepiLandingPage from "./components/repi/repiLandingPage";
import RatioBookComponent from "./components/ratioBook/ratioBookComponent";
import BusinessBulletinSearchComponent from "./components/search/businessBulletinSearchComponent";
import TableauComponent from "./components/tableau/tableauComponent.jsx";
import UserDetails from "./components/user/userDetails";
import HyperlinkGeneratorComponent from "./components/hyperlink/hyperlinkGenerator";
import ChartLayout from "./components/template/chartLayout";
import FilesLandingPage from "./components/files/filesLandingPage.jsx";
import CustomizableMspLandingPage from "./components/customizableMsp/customizableMspLandingPage.jsx";

import LoginLayout from "./components/template/loginLayout";
import LoginComponent from "./components/login/loginComponent";
import LostPwdComponent from "./components/login/lostPwdComponent";
import LogoutComponent from "./components/login/logoutComponent";
import OldLoginComponent from "./components/login/oldLoginComponent";

import PrivateRoute from "./components/privateRoute";
import PublicRoute from "./components/publicRoute";

import "react-perfect-scrollbar/dist/css/styles.css";
import "react-day-picker/lib/style.css";
import "leaflet/dist/leaflet.css";

import "./openSans.css";
import "./main.scss";
import "./css/common/bulma.min.css";
import "./css/common/bbInputsCommon.scss";
import "./css/variables.scss";
import "./css/common/dayPicker.scss";

const onMissingTranslation = ({ translationId }) => `-${translationId}-`;
library.add(fas);

class App extends React.Component {
    constructor(props) {
        super(props);

        const defLang = getLanguage();
        this.props.initialize({
            languages: [
                { name: "Slovensky", code: "sk-SK" },
                { name: "Česky", code: "cs-CZ" },
                { name: "Deutsch", code: "de-DE" },
                { name: "English", code: "en-US" }
            ],
            options: { onMissingTranslation, defaultLanguage: defLang, renderToStaticMarkup }
        });
        Moment.locale(getMomentLanguage(defLang) || 'sk');
        this.props.fetchTranslations(defLang, this.props.addTranslationForLanguage);
        this.props.fetchHelp();

        if (!localStorage.locales_login) {
            localStorage.setItem('locales_login', 'blue');
        }
    }

    render() {
        if (isRepiWeb()) {
            return (
                <Switch>
                    <Route exact path="/" component={HomeComponent}></Route>
                    <PrivateRoute path="/itrade" component={TableauComponent} layout={ChartLayout} permission="EmbeddedItrade" />
                    <PrivateRoute path="/irating" component={IratingComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/contact" component={ContactComponent} layout={PrivateLayoutNew} permission="MainContacts" />
                    <PrivateRoute path="/news/:id" component={NewsDetailComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/news" component={NewsComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/news-notifications" component={NewsComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/user' component={UserDetails} layout={PrivateLayoutNew} permission='PanelUser' deny='PanelUserDENYDetail' />
                    <PrivateRoute path="/repi" component={RepiLandingPage} layout={RepiLayout} permission="MainRepi" />
                    <PrivateRoute path="/files" component={FilesLandingPage} layout={PrivateLayoutNew} />
                    <PublicRoute exact path="/not-found" component={NotFoundComponent} />
                    <PublicRoute exact path="/error/:id" component={NotFoundComponent} />
                    <PublicRoute exact path="/notAuthorized" component={NotAuthorizedComponent} />
                    <PrivateRoute path="/styling" component={StylingComponent} layout={PrivateLayoutNew} permission='NarniaShowcase' />
                    <PublicRoute path="/login" component={LoginComponent} layout={LoginLayout} />
                    <PublicRoute path="/Account/Login" component={OldLoginComponent} />
                    <PublicRoute path="/lost-password" component={LostPwdComponent} layout={LoginLayout} />
                    <PublicRoute path="/logout" component={LogoutComponent} layout={LoginLayout} />
                    <PublicRoute path='/cookie-info-link' component={CookieInfoComponent} layout={PublicLayout} />
                    <PublicRoute path='/privacy-policy' component={PrivacyPolicyInfoComponent} layout={PublicLayout} />
                    <PublicRoute component={NotFoundComponent} layout={PublicLayout} />
                </Switch>
            );
        }

        return (
            <>
                {/* <Route path='/' component={CookieComponent}></Route> */}
                <Switch>
                    <Route exact path="/" component={HomeComponent}></Route>
                    <PrivateRoute path="/report" component={ReportComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/unlimited/:report/:id/:section" component={ReportUnlimitedComponent} />
                    <PrivateRoute exact path="/search" component={SearchComponent} layout={PrivateLayoutNew} permission="MainSearch" pageClass="search" />
                    <PrivateRoute path='/search/results' component={SearchResults} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/relations' component={RelationsSearchLandingPage} layout={PrivateLayoutNew} permission="RelationsReportSearch" />
                    <PrivateRoute path='/search/customizable-msp' component={CustomizableMspLandingPage} layout={PrivateLayoutNew} permission="CustomizableMSPEvaluation" />

                    <PrivateRoute path='/search/cee' component={CeeSearchComponent} componentProps={{ registry: `cee` }} layout={PrivateLayoutNew} permission="SearchCEE" />
                    <PrivateRoute path='/search/cre' component={CeeSearchComponent} componentProps={{ registry: `cre` }} layout={PrivateLayoutNew} permission="SearchCRE" />
                    <PrivateRoute path='/search/aml' component={CeeSearchComponent} componentProps={{ registry: `aml` }} layout={PrivateLayoutNew} permission="AMLsearch" />
                    <PrivateRoute path='/search/rpve' component={CeeSearchComponent} componentProps={{ registry: `cre` }} layout={PrivateLayoutNew} permission="SearchRPVE" />
                    <PrivateRoute path='/search/basic' component={SearchResults} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/liens' permission="SearchLiensSk" component={LiensSearchComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/industry-analysis' permission="SearchIndustryAnalysis" component={IndustryAnalysisComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/bankruptcy' permission="SearchBankruptcies" component={BankruptcySearchComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/businessBulletin' permission="SearchBusinessBulletin" component={BusinessBulletinSearchComponent} layout={PrivateLayoutNew}/>
                    <PrivateRoute path='/search/property-cz' permission="SearchCadastreCz" component={PropertyCzSearchComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/property-sk' permission="SearchCadastreSk" component={PropertySkSearchComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/search/ratioBook' component={RatioBookComponent} layout={PrivateLayoutNew} permission='SearchRatioBook' />
                    <PrivateRoute path='/search/conflictOfInterest' component={ConflictOfInterestSearchComponent} layout={PrivateLayoutNew} permission='ReferenceListConflict' />
                    <PrivateRoute path="/warnings/:id" component={WarningsReportComponent} />
                    <PrivateRoute path="/monitoring" component={MonitoringLandingPage} layout={PrivateLayoutNew} permission="MainMonitoring" />
                    <PrivateRoute path="/itrade" component={TableauComponent} layout={ChartLayout} permission="EmbeddedItrade" />
                    <PrivateRoute path="/skyminder/sso" component={SkyminderSsoComponent} permission="SkyMinderRegistered" deny="SkyMinderDisabled" />
                    <PrivateRoute path="/skyminder" component={SkyminderComponent} layout={PrivateLayoutNew} deny="SkyMinderDisabled" />
                    <PrivateRoute path="/aml-info-check" component={AmlInfoCheckComponent} layout={PrivateLayoutNew} permission="AMLInfoCheckRegistered" />
                    <PrivateRoute path="/irating" component={IratingComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/contact" component={ContactComponent} layout={PrivateLayoutNew} permission="MainContacts" />
                    <PrivateRoute path="/personal-data" component={PersonalDataComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/relation-chart/:id" component={RelationChartComponent} layout={ChartLayout} permission="RelationsReport" componentProps={{ key: this.props.location }} />
                    <PrivateRoute path="/unicorn/overview/:id/:exportId" component={MarketingListOverviewWindow} permission="MarketingList" />
                    <PrivateRoute path="/unicorn/cz" component={MarketingListLandingPage} layout={PrivateLayoutNew} permission="MarketingList" />
                    <PrivateRoute path="/unicorn/sk" component={MarketingListLandingPage} layout={PrivateLayoutNew} permission="MarketingList" />
                    <PrivateRoute path="/news/:id" component={NewsDetailComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/news" component={NewsComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/news-notifications" component={NewsComponent} layout={PrivateLayoutNew} />
                    <PrivateRoute path='/user' component={UserDetails} layout={PrivateLayoutNew} permission='PanelUser' deny='PanelUserDENYDetail' />
                    <PrivateRoute path='/related-address/:id/:idAddress' component={RelationsAddressesData} layout={PrivateLayoutNew} />
                    <PrivateRoute path="/repi" component={RepiLandingPage} layout={PrivateLayoutNew} permission="MainRepi" />
                    <PrivateRoute path="/files" component={FilesLandingPage} layout={PrivateLayoutNew} />

                    <PublicRoute exact path="/not-found" component={NotFoundComponent} />
                    <PublicRoute exact path="/error/:id" component={NotFoundComponent} />
                    <PublicRoute exact path="/notAuthorized" component={NotAuthorizedComponent} />
                    <PrivateRoute path="/styling" component={StylingComponent} layout={PrivateLayoutNew} permission='NarniaShowcase' />

                    <PublicRoute path="/login" component={LoginComponent} layout={LoginLayout} />
                    <PublicRoute path="/lost-password" component={LostPwdComponent} layout={LoginLayout} />
                    <PublicRoute path="/logout" component={LogoutComponent} layout={LoginLayout} />
                    <Route path="/hyperlink/generate-token" component={HyperlinkGeneratorComponent} />
                    <PublicRoute path='/cookie-info-link' component={CookieInfoComponent} layout={PublicLayout} />
                    <PublicRoute path='/privacy-policy' component={PrivacyPolicyInfoComponent} layout={PublicLayout} />

          <PublicRoute component={NotFoundComponent} layout={PublicLayout} />
        </Switch>
      </>
    );
  }

    UNSAFE_componentWillMount() {
        if (isRepiWeb()) {
            document.title = "REPI";
        }
    }
}

export default withRouter(
  withLocalize(
    connect(
      state => state.userContext,
      dispatch => bindActionCreators(userContextActions, dispatch)
    )(App)
  )
);
